import { useState } from 'react';
import axios from '../api/axiosInstance';

function CronSettings() {
  const [hour, setHour] = useState(0);
  const [minute, setMinute] = useState(0);
  const [weekdays, setWeekdays] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const submitCron = async () => {
    const weekdaysArray = weekdays
      .split(',')
      .map(str => Number(str.trim()))
      .filter(n => !isNaN(n) && n >= 0 && n <= 6);

    if (
      isNaN(hour) || hour < 0 || hour > 23 ||
      isNaN(minute) || minute < 0 || minute > 59 ||
      weekdaysArray.length === 0
    ) {
      alert("❌ Будь ласка, введіть дійсну годину (0–23), хвилину (0–59) та принаймні один дійсний день тижня (0–6).");
      return;
    }

    setLoading(true);
    setSuccess(false);
    try {
      await axios.post('/cron/configure_cron', {
        hour,
        minute,
        weekdays: weekdaysArray
      });
      setSuccess(true);
    } catch (e) {
      console.error(e);
      alert('❌ Помилка сервера. Перевірте введені дані або спробуйте пізніше.');
      console.log(e.response?.data);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto bg-white p-6 rounded shadow mt-10">
      <h2 className="text-xl font-bold mb-4 text-center">Налаштування оновлення</h2>
      <div className="space-y-4">

        <div>
          <label className="block text-sm font-medium text-gray-700">Година (0–23)</label>
          <input
            type="number"
            min="0"
            max="23"
            value={hour}
            onChange={e => setHour(+e.target.value)}
            className="w-full border p-2 rounded"
          />
          <p className="text-xs text-gray-500 mt-1">Година доби для виконання завдання.</p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">Хвилина (0–59)</label>
          <input
            type="number"
            min="0"
            max="59"
            value={minute}
            onChange={e => setMinute(+e.target.value)}
            className="w-full border p-2 rounded"
          />
          <p className="text-xs text-gray-500 mt-1">Хвилини в межах години.</p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">Дні тижня</label>
          <input
            type="text"
            placeholder="напр. 1,4 (Понеділок & Четвер)"
            value={weekdays}
            onChange={e => setWeekdays(e.target.value)}
            className="w-full border p-2 rounded"
          />
          <p className="text-xs text-gray-500 mt-1">Введіть числа, розділені комами (0 = неділя, 6 = субота).</p>
        </div>

        <button
          onClick={submitCron}
          disabled={loading}
          className="bg-blue-600 text-white w-full py-2 rounded hover:bg-blue-700 disabled:opacity-50"
        >
          {loading ? 'Зберігання...' : 'Зберегти'}
        </button>

        {success && <p className="text-green-600 text-sm text-center">✓ Налаштування успішно збережені</p>}
      </div>
    </div>
  );
}

export default CronSettings;
